import { useNavigate } from 'react-router-dom';
import { PLATAFORMA_HERO_PILARES, PLATAFORMA_HERO_WOMAN } from '../data';

export default function PlataformaHero() {
  const navigate = useNavigate();

  const scrollToModulos = () => {
    const el = document.querySelector('#modulos');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="plataforma-hero" className="relative overflow-hidden bg-background-50 pb-14 pt-28 md:pb-20 md:pt-36">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -right-28 -top-24 h-[540px] w-[540px] rounded-full bg-primary-100/70 blur-3xl"></div>
        <div className="absolute right-[6%] top-[8%] h-[440px] w-[440px] rounded-full bg-primary-200/45 blur-2xl"></div>
        <div className="absolute -left-32 bottom-0 h-[380px] w-[380px] rounded-full bg-accent-100/60 blur-3xl"></div>
      </div>

      <div className="relative mx-auto grid w-full max-w-[1240px] grid-cols-1 items-center gap-12 px-6 lg:grid-cols-[1.02fr_0.98fr] lg:gap-4">
        {/* Coluna de texto */}
        <div>
          <span className="lp-fade-up inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-2 text-[11px] font-bold uppercase tracking-[0.18em] text-primary-700">
            <i className="ri-stack-line text-sm"></i>
            Tudo em um só ecossistema
          </span>

          <h1 className="lp-fade-up lp-delay-1 mt-6 font-heading text-4xl font-extrabold leading-[1.04] tracking-[-0.02em] text-foreground-950 md:text-5xl lg:text-[3.4rem]">
            Uma plataforma,
            <br />
            todas as etapas do <span className="text-primary-500">incentivo.</span>
          </h1>

          <p className="lp-fade-up lp-delay-2 mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            Da estratégia à premiação: campanhas, gamificação, app do participante, carteira digital,
            apuração de resultados e conformidade — conectados em um único lugar, do planejamento ao resgate.
          </p>

          <div className="lp-fade-up lp-delay-3 mt-8 flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={() => navigate('/solicitar-demo')}
              className="inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              Agende uma demonstração
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
            <button
              type="button"
              onClick={scrollToModulos}
              className="inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-7 text-sm font-semibold text-foreground-900 transition-colors hover:bg-background-100"
            >
              <i className="ri-layout-grid-line text-lg text-primary-500"></i>
              Explorar módulos
            </button>
          </div>
        </div>

        {/* Coluna da imagem */}
        <div className="relative mx-auto w-full max-w-[560px]">
          <img
            src={PLATAFORMA_HERO_WOMAN}
            alt="Participante comemorando os resultados conquistados na plataforma de incentivo GetPoints, com indicadores de +32% de engajamento e conquistas que geram resultados"
            className="lp-fade-up lp-delay-2 h-full w-full object-contain"
          />
        </div>
      </div>

      {/* Pills dos pilares */}
      <div className="relative mx-auto mt-14 w-full max-w-[1120px] px-6">
        <div className="lp-fade-up lp-delay-4 flex flex-wrap items-center justify-center gap-3">
          {PLATAFORMA_HERO_PILARES.map((pilar) => (
            <span
              key={pilar.label}
              className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800"
            >
              <i className={`${pilar.icon} text-lg text-primary-500`}></i>
              {pilar.label}
            </span>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <button
            type="button"
            onClick={scrollToModulos}
            className="inline-flex cursor-pointer items-center gap-2 text-sm font-medium text-foreground-500 transition-colors hover:text-primary-600"
          >
            <i className="ri-arrow-down-line text-lg text-primary-500"></i>
            Conheça a plataforma
          </button>
        </div>
      </div>
    </section>
  );
}